import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ActivateDigitalWalletRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ActivateDigitalWalletResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const activateDigitalWallet = (request: ActivateDigitalWalletRequest, options?: CashRequestOptions) =>
  post<ActivateDigitalWalletRequest, ActivateDigitalWalletResponse>('/2.0/cash/activate-digital-wallet', request, {
    ...options,
    rejectOnError: true,
  })
